import { motion } from "framer-motion";
import { LayoutGrid, QrCode, RefreshCw, Users } from "lucide-react";

// Posicionales: el orden debe seguir a t.features.items.
const icons = [LayoutGrid, QrCode, RefreshCw, Users];

export const SectionHead = ({ kicker, title, subtitle }) => (
  <div className="max-w-2xl mb-14">
    <p className="text-xs md:text-sm uppercase tracking-[0.2em] font-bold text-orange-500 mb-4">{kicker}</p>
    <h2 className="font-heading text-3xl md:text-4xl font-semibold tracking-tight text-white">{title}</h2>
    <p className="mt-4 text-base text-zinc-400 leading-relaxed">{subtitle}</p>
  </div>
);

export const Features = ({ t }) => (
  <section id="features" data-testid="features-section" className="py-24 md:py-32 bg-[#050505]">
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <SectionHead kicker={t.features.kicker} title={t.features.title} subtitle={t.features.subtitle} />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {t.features.items.map((item, i) => {
          const Icon = icons[i];
          return (
            <motion.div
              key={item.title}
              data-testid={`feature-card-${i}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ delay: i * 0.1, duration: 0.5 }}
              className="group bg-[#0F0F0F] border border-white/10 hover:border-orange-500/50 rounded-2xl p-8 transition-colors duration-300 hover:-translate-y-1 transform"
            >
              <div className="w-11 h-11 rounded-xl bg-orange-500/10 border border-orange-500/20 flex items-center justify-center mb-6 group-hover:shadow-[0_0_15px_rgba(247,147,26,0.3)] transition-shadow">
                <Icon className="w-5 h-5 text-[#F7931A]" />
              </div>
              <h3 className="font-heading text-lg font-medium text-white mb-3">{item.title}</h3>
              <p className="text-sm text-zinc-400 leading-relaxed">{item.desc}</p>
            </motion.div>
          );
        })}
      </div>
    </div>
  </section>
);
